import React from "react";
import Modal from "../Modal";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import Button from "../Button";

function RemoveModal({ open, setOpen, btnInfo, heading, cumWidth, oneLiner, isBold, children,description,gap = 2 }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const handleClose = () => setOpen(false);
  
  return (
    <>
      <Modal open={open} handleClose={handleClose} style={{ width: isSmallScreen ? "auto" : cumWidth ? cumWidth : "450px" }}>
        <Grid container gap={gap} width="100%" marginTop = "13px">
          <Grid item lg={12} width="100%" sx={{ textAlign: isSmallScreen ? "center" : "center" }}>
            <Typography sx={{ 
              whiteSpace: oneLiner ? "" : "nowrap", 
              fontFamily: "Poppins", 
              fontWeight: 500, 
              fontSize: oneLiner ? "16px !important" : "18px", 
              lineHeight: "22px",
              mb: description ? 1 : 0 // Add margin bottom if there's a description
            }}>
              {isBold
                ? heading.split(/(\*.*?\*)/).map((part, idx) =>
                  part.startsWith("*") && part.endsWith("*") ? (
                    <span style={{ fontWeight: "600" }} key={idx}>
                      {part.slice(1, -1)}
                    </span>
                  ) : (
                    part
                  )
                )
                : heading}
            </Typography>
            
            {/* Add description rendering */}
            {description && (
              <Typography sx={{ 
                fontFamily: "Karla", 
                fontWeight: 500, 
                fontSize: "13px", 
                lineHeight: "22px",
                letterSpacing: "-0.41px",
                color: "#000000",
                mt: 1,
                mb: 2,
                textAlign: "center"
              }}>
                {description}
              </Typography>
            )}
          </Grid>
          {children && (
            <Grid item lg={12} width="100%">
              {children}
            </Grid>
          )}
          <Grid item lg={12} width="100%">
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }} gap={6}>
              {btnInfo?.map((btn, index) => (
                <Box key={btn.btnName} width={"100%"}>
                  <Button
                    disabled={btn.disabled}
                    sx={{
                      width: "100%",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px",
                      lineHeight: "22px",
                      height: "50px",
                      borderRadius: "5px",
                      color: btn.color || "#000000",
                      marginTop: "20px",
                      textTransform: "none",
                      border: `1px solid ${btn.bgColor}`,
                      "&:hover": {
                        backgroundColor: btn.bgColor,
                      },
                      "&.Mui-disabled": {
                        color: btn.color || "#000000",
                        backgroundColor: btn.bgColor,
                        border: `1px solid ${btn.bgColor}`,
                      },
                      backgroundColor: btn.bgColor,
                    }}
                    onClick={btn.click}
                  >
                    {btn.btnName}
                  </Button>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
}

export default RemoveModal;
